var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable, timer, Subject } from 'rxjs';
import { EditPaintState } from 'src/app/edit/state/paint/edit.paint.state';
import { filter, debounce, takeUntil } from 'rxjs/operators';
import { SetColorRecipe } from 'src/app/edit/state/paint/edit.paint.actions';
import { ColorService } from 'src/app/shared/color.service';
import { ColorFresnelModel } from 'src/app/edit/models/color-fresnel.model';
import { ScalarFresnelModel } from 'src/app/edit/models/scalar-fresnel.model';
import { PaintDefaults } from 'src/app/edit/models/paint-defaults.model';
var PaintWidgetComponent = /** @class */ (function () {
    function PaintWidgetComponent(formBuilder, store, colorService, changeDetector) {
        this.formBuilder = formBuilder;
        this.store = store;
        this.colorService = colorService;
        this.changeDetector = changeDetector;
        this.colorPickerHex = '#ffffff';
        this.fresnelColor = false;
        this.fresnelOpacity = false;
        this.ngUnsubscribe = new Subject();
        this.form = this.formBuilder.group({
            'tintColor': [__spread(PaintDefaults.tintColor)],
            'saturation': [PaintDefaults.saturation],
            'contrast': [PaintDefaults.contrast],
            'brightness': [PaintDefaults.brightness],
            'opacity': [PaintDefaults.opacity]
        });
    }
    PaintWidgetComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Handle change to color recipe
        this.colorRecipe$
            .pipe(filter(function (colorRecipe) {
            return colorRecipe != null &&
                JSON.stringify(colorRecipe) !== JSON.stringify(_this.colorRecipe);
        }, takeUntil(this.ngUnsubscribe))).subscribe(function (colorRecipe) {
            _this.colorRecipe = colorRecipe;
            _this.fresnelColor = colorRecipe.tintColor instanceof ColorFresnelModel;
            _this.fresnelOpacity = colorRecipe.opacity instanceof ScalarFresnelModel;
            _this.setFormValues(colorRecipe);
            _this.changeDetector.markForCheck();
        });
        // Handle change in form
        this.form.valueChanges
            .pipe(debounce(function () { return timer(300); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (values) {
            _this.handleFormChanges(values);
        });
    };
    PaintWidgetComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    PaintWidgetComponent.prototype.setFormValues = function (colorRecipe) {
        // Tint
        var tintColor = PaintDefaults.tintColor;
        if (!this.fresnelColor && colorRecipe.tintColor !== false) {
            this.colorPickerHex = this.colorService.rgbToHex(colorRecipe.tintColor, true);
            tintColor = colorRecipe.tintColor;
        }
        // Opacity
        var opacity = PaintDefaults.opacity;
        if (!this.fresnelOpacity && colorRecipe.opacity !== false) {
            opacity = colorRecipe.opacity;
        }
        // Contrast
        var contrast = PaintDefaults.contrast;
        if (colorRecipe.contrast !== false) {
            contrast = colorRecipe.contrast;
        }
        // Brightness
        var brightness = PaintDefaults.brightness;
        if (colorRecipe.brightness !== false) {
            brightness = colorRecipe.brightness;
        }
        // Saturation
        var saturation = PaintDefaults.saturation;
        if (colorRecipe.saturation !== false) {
            saturation = colorRecipe.saturation;
        }
        this.form.setValue({
            tintColor: tintColor,
            saturation: saturation,
            contrast: contrast,
            brightness: brightness,
            opacity: opacity
        });
    };
    PaintWidgetComponent.prototype.handleFormChanges = function (formValues) {
        var recipe = __assign({}, this.colorRecipe);
        recipe.saturation = formValues.saturation;
        recipe.brightness = formValues.brightness;
        recipe.contrast = formValues.contrast;
        if (!this.fresnelOpacity) {
            recipe.opacity = formValues.opacity;
        }
        if (!this.fresnelColor) {
            recipe.tintColor = (typeof formValues.tintColor === 'string') ? this.colorService.hexToRgb(formValues.tintColor, true) : formValues.tintColor;
        }
        this.store.dispatch(new SetColorRecipe(recipe));
    };
    PaintWidgetComponent.prototype.handleColorPickerChange = function (color) {
        this.colorPickerHex = color;
        this.form.patchValue({
            'tintColor': this.colorService.hexToRgb(color, true)
        });
    };
    __decorate([
        Select(EditPaintState.getColorRecipe),
        __metadata("design:type", Observable)
    ], PaintWidgetComponent.prototype, "colorRecipe$", void 0);
    return PaintWidgetComponent;
}());
export { PaintWidgetComponent };
